import React from 'react';
import { Box } from '@mui/material';

interface ImageComponentProps {
  src?: string;
  alt?: string;
  width?: number | string;
  height?: number | string;
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
}

export const ImageComponent: React.FC<ImageComponentProps> = ({
  src,
  alt,
  width = '100%',
  height = 'auto',
  style,
  className,
  onClick,
}) => {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <img
        src={src || '/placeholder-image.png'}
        alt={alt || 'Image'}
        width={width}
        height={height}
        style={{
          maxWidth: '100%',
          height: 'auto',
          borderRadius: '8px',
          cursor: onClick ? 'pointer' : 'default',
          ...style,
        }}
        className={className}
        onClick={onClick}
        onError={(e) => {
          // Fallback to placeholder if image fails to load
          e.currentTarget.src = '/placeholder-image.png';
        }}
      />
    </Box>
  );
}; 